import { Controller } from '@hotwired/stimulus'
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';

// Polyfill. Promise.withResolvers() is an ES2023 feature not supported in Safari 16.3 and earlier
if (!Promise.withResolvers) {
    Promise.withResolvers = function () {
        let resolve, reject
        const promise = new Promise((res, rej) => {
            resolve = res
            reject = rej
        })
        return { promise, resolve, reject }
    }
}

export default class extends Controller {
    static targets = ["canvas", "container", "loader"]
    static values = {
        pdfData: String
    }

    connect() {
        pdfjsLib.GlobalWorkerOptions.workerSrc =
         'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/legacy/build/pdf.worker.mjs';

        setTimeout(() => {
            if (window.innerWidth <= 768 && this.hasPdfDataValue) {
                this.initPDF();
            }
        }, 300);
    }

    async initPDF() {
        try {
            if (this.hasLoaderTarget) {
                this.loaderTarget.style.display = 'block';
            }

            const pdfData = atob(this.pdfDataValue);
            const pdfArray = new Uint8Array(pdfData.length);
            for (let i = 0; i < pdfData.length; i++) {
                pdfArray[i] = pdfData.charCodeAt(i);
            }

            const loadingTask = pdfjsLib.getDocument({ data: pdfArray });
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);

            const checkContainerAndRender = () => {
                const containerWidth = this.containerTarget.clientWidth;

                if (containerWidth > 0) {
                    this.renderPage(page, containerWidth);
                } else {
                    setTimeout(checkContainerAndRender, 100);
                }
            };

            checkContainerAndRender();

        } catch (error) {
            console.error('PDF Error:', error);
            if (this.containerTarget) {
                this.containerTarget.innerHTML = `
                    <div class="pdf-error">
                        Failed to load PDF: ${error.message}<br>
                        <a href="data:application/pdf;base64,${this.pdfDataValue}"
                           download="document.pdf">
                            Download instead
                        </a>
                    </div>`;
            }
        } finally {
            if (this.hasLoaderTarget) {
                this.loaderTarget.style.display = 'none';
            }
        }
    }

    async renderPage(page, containerWidth) {
        const canvas = this.canvasTarget;
        const context = canvas.getContext('2d');

        const dpr = window.devicePixelRatio || 1;

        const viewport = page.getViewport({ scale: 1 });
        const scale = (containerWidth * dpr) / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        canvas.width = scaledViewport.width;
        canvas.height = scaledViewport.height;

        canvas.style.width = `${containerWidth}px`;
        canvas.style.height = `${scaledViewport.height / dpr}px`;

        await page.render({
            canvasContext: context,
            viewport: scaledViewport,
            intent: 'print'
        }).promise;
    }

    disconnect() {
        if (this._pdf) {
            this._pdf.cleanup();
            this._pdf.destroy();
        }
        this._pdf = null;
    }
}
